import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import { getUrl } from '~/services/shop/utils';

export default function createBasket() {
    return shop.get(getUrl('/baskets')).json<ShopTypes.BasketResponse>();
}
